<template>
  <div>
    <div class="is-weiXin-tip" v-if="weixinShow">
      <img class="tip-open" src="@/assets/imgs/common/what_tip1.png" alt="">
    </div>
    <div class="register-success-page" v-else>
      <div class="register-success-warp">
        <div class="register-header">
          <img src="@/assets/imgs/invitationPage/zhubiao@2x_2.png" alt="">
        </div>
        <div class="register-success-container">
          <div class="btn">
            <button @click="buttonDownload">下载认证得法临币</button>
          </div>
          <p class="tip">系统将在 <span>{{ counts }}s</span> 后跳转,若未跳转请手动 <span>点击按钮跳转</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCommonClientConfig} from "@a";

export default {
  name: "registerSuccess",
  data(){
    return{
      counts:5,
      downloadUrls:{},
      weixinShow:false
    }
  },
  mounted() {
    if(this.is_weixn()&&this.isAndroidClient()){
      this.weixinShow = true;
    }else{
      this.timer()
    }
  } ,
  methods:{
    /* 倒计时*/
    timer() {
      this.counts = this.$options.data().counts
      this.timerInterval = setInterval(() => {
        if (this.counts > 0) {
          this.counts--
        } else {
          this.clearTimer();
          this.buttonDownload()
        }
      }, 1000)
      this.$on('hook:destroyed', () => {
        this.clearTimer();
      })
    },
    clearTimer() {
      clearInterval(this.timerInterval)
    },
    /*按钮点击下载*/
    buttonDownload () {
      this.getApk().then( (value)=> {
        if(this.isIOSClient()){
          window.location.href = value.downloadGfUrlIos;
        }else{
          /*先喚醒安卓应用市场*/
          window.location.href = value.androidGfAppstoreUrl;
          /*防止安卓没有上架到应用市场*/
          setTimeout(function (){
            window.location.href = value.downloadGfUrlApk;
          },500)
        }
      });
    },
    /*判断是否微信*/
    is_weixn () {
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    /*判断是否安卓*/
    isAndroidClient () {
      return this.judgeClient() === 'Android';
    },
    /*判断是否ios*/
    isIOSClient () {
      return this.judgeClient() === 'IOS';
    },
    /*获取操作系统*/
    judgeClient () {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 ios终端
      if (isAndroid === true) {
        return 'Android';
      } else if (isIOS === true) {
        return 'IOS';
      } else {
        return 'Android';
      }
    },
    /*获取下载地址*/
    getApk () {
      if (this.$basicsTools.isObjNull(this.downloadUrls)) {
        return getCommonClientConfig().then( (value) =>{
          this.downloadUrls = value.data;
          return  this.downloadUrls
        })
      }
      return Promise.resolve(this.downloadUrls)
    },
  }
}
</script>

<style scoped lang="scss">
.register-success-page {
  min-height: 100vh;
  background: #edeff3;
  .register-success-warp{
    min-height: 666px;
    background: url("~@/assets/imgs/invitationPage/bg@2x_2.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
  }
  .register-header{
    padding-top: 74px;
    img{
      display: block;
      margin: 0 auto;
      width: 298px;
      height: 75px;
    }
    box-sizing: border-box;
    padding-bottom: 201px;
  }
  .register-success-container {
    min-height: 286px;
    background: url("~@/assets/imgs/invitationPage/tab@2x_2.png") no-repeat;
    background-size: 100% 100%;
    width: 348px;
    margin: 0 auto;
    .btn {
      padding-top: 203px;
      text-align: center;
      button{
        width: 324px;
        height: 45px;
        background: linear-gradient(90deg, #EEB48E, #B56F4C);
        border-radius: 22px;
        font-size: 17px;
        font-weight: normal;
        color: #FFFFFF;
        border: none;
        outline: none;
      }
    }
    .tip{
      padding-top: 10px;
      font-size: 13px;
      font-weight: normal;
      color: #501D06;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        color: #F4512B;
        line-height: normal;
        display: block;
      }
    }
  }
}
.is-weiXin-tip{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 20;
  text-align: right;
}

.tip-open{
  width: 5.08rem;
  height: 3.52rem;
  position: fixed;
  z-index: 5;
  top: 0;
  right:0.12rem;
}

</style>
